/**
 * Response will look like this:
 * ```
 * {
 *      isSuccessful: Boolean,
 *      message: String,
 *      [apiResult]: Any,
 * }
 * ```
 *
 */

export function handleApiErrorMessage(response) {
  let errMsg = ''
  const errArr = response.message.split('"')

  if (errArr.length > 1 && errArr[1]) errMsg = errArr[1]
  if (errArr.length > 0 && errArr[0] && errMsg == '') errMsg = errArr[0]

  else errMsg = response.message.toString()

  return errMsg
}

export default handleApiErrorMessage
